export default "__VITE_ASSET__DdKbc4_m__"